import React from 'react'

const Testimonios = () => {
  return (
    <div>Testimonios</div>
  )
}

export default Testimonios